/**
 * Date separator used in Chilean date format
 */
export const DATE_SEPARATOR = '/';
/**
 * ISO date string separator
 */
export const ISO_DATE_SEPARATOR = 'T';
/**
 * Number of milliseconds in a day
 */
export const MILLISECONDS_PER_DAY = 1000 * 60 * 60 * 24;
/**
 * Padding character for date formatting
 */
export const PADDING_CHAR = '0';
